import { scrollMemoryRouteNames } from '../consts';
import { RouteNameEnum } from '../enums';

import { getUrlByRouteName } from './getUrlByRouteName.utils';

export const getScrollMemoryPaths: () => string[] = (): string[] => scrollMemoryRouteNames
  .map((routeName: RouteNameEnum): string | undefined => getUrlByRouteName(routeName)?.url)
  .filter((path: string | undefined): path is string => path !== undefined);
